import { useState } from 'react';
export const useCFToggle = ({ initialChecked = false, onChange, }) => {
    const [checked, setChecked] = useState(initialChecked || false);
    const updateChecked = (c = false, event) => {
        setChecked(c);
        if (onChange)
            onChange(c, { event });
    };
    return {
        checked,
        setChecked: (c) => {
            if (c === checked)
                return;
            setChecked(c || false);
        },
        updateChecked,
    };
};
